import axios from 'axios'
import { decryptData, encryptData } from './tweetnacl'

const CLIENT_ID = process.env.REACT_APP_SIGN_API_CLIENT_ID || null

// import { decryptData, encryptData } from './components'
//All Backend API connections are done here
const apiCall = async (method, url, data, headertype, baseurl, custom, configOptions = {}) => {
    if (global.decryptData && data) {
        data = data instanceof FormData ? data : encryptData(data)
    }

    let site_url = `${global.site_url}/api/user/`

    if (global.bidding_cron && baseurl === 'bid' && url === 'confirm') {
        site_url = `${global.cron_site_url}/api/${baseurl}/`
    } else {
        if (baseurl) {
            site_url = `${global.site_url}/api/${baseurl}/`
        }
        if (custom) {
            site_url = `${global.site_url}/api/custom/`
            if (baseurl) {
                site_url = `${global.site_url}/api/custom/${baseurl}/`
            }
        }
    }

    return new Promise(async (resolve, reject) => {
        let type = ''
        if (headertype && headertype === 'formdata') {
            type = 'multipart/form-data'
        } else {
            type = 'application/json'
        }

        let headers = {
            'content-type': type,
        }

        const WHITELIST_KEYWORDS = ['updateProfile', 'addCompanyOwner']
        const isWhitelisted = WHITELIST_KEYWORDS.some((keyword) => url.includes(keyword))

        if (!isWhitelisted && CLIENT_ID && typeof CLIENT_ID !== 'undefined') {
            const [{ default: privateKey }, jsrsasign, bufferModule, { default: stringify }] =
                await Promise.all([
                    import('../keys/client_private'),
                    import('jsrsasign'),
                    import('buffer'),
                    import('fast-json-stable-stringify'),
                ])

            const { KEYUTIL, KJUR } = jsrsasign
            const { Buffer } = bufferModule

            window.Buffer = Buffer
            const timestamp = Math.floor(Date.now() / 1000).toString()

            const hashObject = {
                url: site_url + url,
                method: method.toUpperCase(),
            }

            const dataToSign = timestamp + stringify(hashObject)

            try {
                const prvKey = KEYUTIL.getKey(privateKey)

                const sig = new KJUR.crypto.Signature({ alg: 'SHA256withRSA' })
                sig.init(prvKey)
                sig.updateString(dataToSign)

                const sigHex = sig.sign()
                const signatureBase64 = Buffer.from(sigHex, 'hex').toString('base64')

                headers['x-client-id'] = CLIENT_ID
                headers['x-signature'] = signatureBase64
                headers['x-timestamp'] = timestamp
            } catch (signErr) {
                console.error('[SIGN ERROR]', signErr)
                // Decide: continue without signature or throw
            }
        }

        const config = { headers, ...configOptions }

        switch (method) {
            case 'post':
                try {
                    data = data ? data : {}
                    const res = await axios.post(`${site_url}${url}`, data, config)
                    if (global.decryptData && res.data) {
                        res.data = data instanceof FormData ? res.data : decryptData(res.data)
                    }
                    resolve(res)
                } catch (err) {
                    console.log('responsode error from api', err)
                    if (global.decryptData && err.data) {
                        err.data = decryptData(err.data)
                    }
                    resolve(err)
                }
                break
            case 'get':
                try {
                    const res = await axios.get(`${site_url}${url}`, config)
                    if (global.decryptData && res.data) {
                        res.data = decryptData(res.data)
                    }
                    resolve(res)
                } catch (err) {
                    console.log('responsode error from api', err)
                    if (global.decryptData && err.data) {
                        err.data = decryptData(err.data)
                    }
                    resolve(err)
                }
                break
            default:
                return null
                break
        }
    })
}

const apiCallSeller = async (method, url, data, headertype, baseurl, common, custom) => {
    if (global.decryptData && data) {
        data = data instanceof FormData ? data : encryptData(data)
    }
    let site_url = `${global.site_url}/api/seller/`
    if (baseurl) {
        site_url = `${global.site_url}/api/seller/${baseurl}/`
    }

    if (common) {
        site_url = `${global.site_url}/api/commonFunction/`
        if (baseurl) {
            site_url = `${global.site_url}/api/commonFunction/${baseurl}/`
        }
    }

    if (custom) {
        site_url = `${global.site_url}/api/custom/`
        if (baseurl) {
            site_url = `${global.site_url}/api/custom/${baseurl}/`
        }
    }

    return new Promise(async (resolve, reject) => {
        let type = ''
        if (headertype && headertype === 'formdata') {
            type = 'multipart/form-data'
        } else {
            type = 'application/json'
        }

        let headers = {
            'content-type': type,
        }

        const WHITELIST_KEYWORDS = ['updateProfile', 'addCompanyOwner']

        const isWhitelisted = WHITELIST_KEYWORDS.some((keyword) => url.includes(keyword))

        if (!isWhitelisted && CLIENT_ID && typeof CLIENT_ID !== 'undefined') {
            const [{ default: privateKey }, jsrsasign, bufferModule, { default: stringify }] =
                await Promise.all([
                    import('../keys/client_private'),
                    import('jsrsasign'),
                    import('buffer'),
                    import('fast-json-stable-stringify'),
                ])

            const { KEYUTIL, KJUR } = jsrsasign
            const { Buffer } = bufferModule

            window.Buffer = Buffer
            const timestamp = Math.floor(Date.now() / 1000).toString()

            const hashObject = {
                url: site_url + url,
                method: method.toUpperCase(),
            }

            const dataToSign = timestamp + stringify(hashObject)

            try {
                const prvKey = KEYUTIL.getKey(privateKey)

                const sig = new KJUR.crypto.Signature({ alg: 'SHA256withRSA' })
                sig.init(prvKey)
                sig.updateString(dataToSign)

                const sigHex = sig.sign()
                const signatureBase64 = Buffer.from(sigHex, 'hex').toString('base64')

                headers['x-client-id'] = CLIENT_ID
                headers['x-signature'] = signatureBase64
                headers['x-timestamp'] = timestamp
            } catch (signErr) {
                console.error('[SIGN ERROR]', signErr)
                // Decide: continue without signature or throw
            }
        }

        const config = { headers }

        switch (method) {
            case 'post':
                try {
                    data = data ? data : {}
                    const res = await axios.post(`${site_url}${url}`, data, config)
                    console.log('responsode from api', res)
                    if (global.decryptData && res.data) {
                        res.data = data instanceof FormData ? res.data : decryptData(res.data)
                    }
                    resolve(res)
                } catch (err) {
                    console.log('responsode error from api', err)
                    if (global.decryptData && err.data) {
                        err.data = decryptData(err.data)
                    }
                    resolve(err)
                }
                break
            case 'get':
                try {
                    const res = await axios.get(`${site_url}${url}`, config)

                    if (global.decryptData && res.data) {
                        res.data = decryptData(res.data)
                    }
                    resolve(res)
                } catch (err) {
                    console.log('responsode error from api', err)
                    if (global.decryptData && err.data) {
                        err.data = decryptData(err.data)
                    }
                    resolve(err)
                }
                break
            default:
                return null
                break
        }
    })
}

const setAuthToken = (token) => {
    if (token) {
        axios.defaults.headers.common['authorization'] = `Bearer ${token}`
    } else {
        delete axios.defaults.headers.common['authorization']
    }
}

const setIPAddress = (ipaddress) => {
    if (ipaddress) {
        axios.defaults.headers.common['ipaddress'] = ipaddress
    } else {
        delete axios.defaults.headers.common['ipaddress']
    }
}

const setLocation = (location) => {
    if (location) {
        axios.defaults.headers.common['location'] = location
    } else {
        delete axios.defaults.headers.common['location']
    }
}

export { apiCall, apiCallSeller, setAuthToken, setIPAddress, setLocation }
